 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"668f687a0e93c5566737","1":"5eb9f97a531c82c7d60e","2":"b407f39028790aede58f","3":"47961de6029037d061f2","4":"e1bb5e2df1446d0b2d28","5":"c8951135ea17c0be1bbe","6":"74f982511be7e13153db","7":"a899c4cab2f05f8e80f8","vendors~Comment~LoginDialog":"9a27245859b6e9603ab4","vendors~Comment~ShareComment":"51dd21ed67781fe33121","vendors~Comment~Survey":"5b3137d7959a92c4dbf8","Comment":"e5960ec0ef2394fdf717","vendors~Player":"7d1a702854f63c13c5e1","Player":"ac438a13f96309683fa4","AccountOpening":"a9fb2dce03feb64a1dce","BackTopBottom":"07400e977fd908451c2f","Caption":"2ff8058c3f256b02d214","Copyright":"3ed6e9b05692a0e3e076","DataBox":"21332dac729ebd33f42c","LivePlayer":"2af7ed81d45d171a10a4","MoreTabs":"cb4d1a3d5623ce4d4cf7","Nav":"1be38448b9a4323b472f","NormalCaption":"3c55e75057aec0b7aa00","Offline":"bf26e6061c2322637010","Stick":"52440f2f03da65094026","Tip":"2a5db2c8443a4ea25c15","ViewMoreLink":"073a17f90ac956a8fc04","WxLaunchApp":"1251f51c7b77f980fddd","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"c361e4ee218b154a1284","Atlas":"05b99716655268d9db83","FiveNavPic":"912ef10294b677e8b235","FourNavPic":"d89ac25d1c91cf60e295","vendors~MdBanner":"9b7472cb42201be95b49","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"5c8c8d21e51bc37ec584","CallupVideoAppHead":"b3a6d1eb0d512d22b7d4","HomeFooter":"2f001e478cf7ccbd31b4","Hongbao":"8ef87d4c4dc34bb6563c","ThreeNavPic":"ec0c53bab4b4c61d9114","vendors~BigImage~BigImg~BigTopic~InformationFlow~NewsStream~OneImage~SlideImg~ThreeImage~TitleImg~Tw~9fd299ab":"45456559e223ca2918fd","TwoImage":"371221ac37c2920ead97","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"6ea9c322ff02195559c8","BigImage":"59af0f867e54e52060d1","OneImage":"e15d440230c8954fbc5e","ThreeImage":"e54803720411149492b2","vendors~NewsStream":"e0005ed6f38abe0dca8c","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"ad472025733caa0f9055","TwoImg":"f234be1bdd0332dd4ff2","InformationFlow":"a301f7e704dd62951181","vendors~BigImg":"130b634e24e8f68cf016","BigImg":"bdae2f341a958331ed3d","vendors~BigTopic~TitleImg":"97997a7167aa73842707","BigTopic":"4123ce947a7c9c59ed7e","TitleImg":"fe1be48fbaac8a6f35cf","vendors~SlideImg":"56708a3271a557e5c938","NoImage":"4fdb32e8c0c53d01e27e","SingleTitle":"bcd95ab7b8341fca9c74","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"4b5be1a1cf3c07ba36ac","NormalSlides":"a6167f4259cdd0b83e15","ShareSlides":"3839829036d26cbf20d6","vendors~BottomSlides~UpgradeBottomSlides":"39383faeaeeee80538b3","UpgradeBottomSlides":"f0e0a590024014bc73b6","vendors~IndexSlides":"d5d5aa8d3527bd6b53bd","vendors~BrowserGuideLayer":"a5d9f1724dde0ebbef73","vendors~CallupHead":"65e7ced8b938718b2b07","vendors~ShareComment":"50377f8553207da79eaf","vendors~Survey":"7cb6150e03fd35df922f","vendors~NormalTabs":"3eee29cfc43f3ae7c765","vendors~WXGuideLayer":"e6c6a4e9380859b688b8","LoginDialog":"a20c69efe600b9927043","vendors~Img":"3854d980dd12fb3887a5","vendors~MarkTabs":"f836bbdbd9bf564a3021","vendors~PageBottomBrand":"d13c81b514c68b3c3b82","vendors~QQShare":"a4e93c691861d433e0c7","vendors~SimpleGuideLayer":"26da63c643cdf6062a73","vendors~SlidesTabs":"70dbb225c1799197a714","vendors~pics":"c60ed2f8184830123353","pics":"e6eee10d22ba7dc3b5b2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
